(ns nosco.i18n.translate-utils
  (:require [clojure.string :as string]))

(def ^:private DEBUG-TRANSLATIONS false)

(defn- replace-with-dummy-chars [s]
  (when s
    (apply str (take (count s) (repeat "\u2589")))))

(defn- capitalize
  "Like clojure.string/capitalize but do not lower case any letter"
  [s]
  (let [s (str s)]
    (if (< (count s) 2)
      (string/upper-case s)
      (str (string/upper-case (subs s 0 1))
           (subs s 1)))))

(defn format-translation-text-impl [translated-text vars]
  (let [;; Sometimes we force the downcasing of parameters.
        ;; Since parameters may not appear at the same position in the source string and the translated string,
        ;; we capitalize the translated string if it begins with a parameter.
        capitalize? (string/starts-with? translated-text "%s")
        formated-translation-text (loop [s nil
                                         texts (string/split (str translated-text) #"%s")
                                         vars vars]
                                    (if-let [t (first texts)]
                                      (recur (str s t (first vars)) (rest texts) (rest vars))
                                      (if DEBUG-TRANSLATIONS
                                        (replace-with-dummy-chars s)
                                        s)))]
    (if capitalize?
      (capitalize formated-translation-text)
      formated-translation-text)))
